import React, { useContext } from 'react'
import { array, func, number } from 'prop-types'
import styled from 'styled-components'

import CheckoutContext from 'contexts/Checkout'
import NativeAuthContext from 'components/NativeAuth'
import Cartridge from 'components/buy/Cartridge'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'

const Container = styled.div`
  position: static;

  ${media.medium`
    margin-top: ${spacing.xLarge};
  `};

  ${media.large`
    margin-top: ${spacing.xxLarge};
  `};
`

const Inner = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -${spacing.small};
`

const Item = styled.div`
  display: flex;
  width: 50%;
  padding: ${spacing.small};

  ${media.small`
    width: 33.333%;
  `};

  ${media.medium`
    width: 50%;
  `};

  ${media.large`
    width: 33.333%;
  `};
`

const BuyCartridges = ({
  cartridges,
  handleAddCartridge,
  handleCartridgeRemove,
  multipackLimit,
  currentCartridgeQuantity
}) => {
  const { products } = useContext(CheckoutContext)
  const { province } = useContext(NativeAuthContext)

  return (
    <Container>
      <Inner>
        {cartridges.map((cartridge, idx) => {
          const fetchedProduct = products.find(p => cartridge.id.includes(p.shopifyGid))

          if (fetchedProduct && !fetchedProduct?.availableProvinces.includes(province)) {
            return null
          }

          return (
            <Item key={cartridge.title + idx}>
              <Cartridge
                product={cartridge}
                handleCartridgeVariantQuantityChange={handleAddCartridge}
                handleCartridgeRemove={handleCartridgeRemove}
                buttonLabel="Add"
                multipackLimit={multipackLimit}
                currentCartridgeQuantity={currentCartridgeQuantity}
              />
            </Item>
          )
        })}
      </Inner>
    </Container>
  )
}

BuyCartridges.propTypes = {
  cartridges: array.isRequired,
  handleAddCartridge: func.isRequired,
  handleCartridgeRemove: func.isRequired,
  multipackLimit: number,
  currentCartridgeQuantity: func
}

export default BuyCartridges
